import React, { useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import '@/pages/opinion/assets/scss/pages/dataMap/newsCrawlers.scss';

import Data from '../components/data';
import { useIntl } from 'umi';
import NewsCrawlersPoint from '@op/operationLog/pages/newsCrawlers';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import { getDataMapNews } from '@/pages/opinion/services';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { keywordRenderFunc } from '@/pages/opinion/utils/text';
const { Body, Content } = Layout;

const NewsCrawlers = () => {
  const { formatMessage } = useIntl();
  useInitBuriedPointInfo({ buriedPoint: NewsCrawlersPoint });

  const [crawlers, setCrawlers] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    setLoading(true);
    const data = await getDataMapNews({
      page: 1,
      page_size: 1000,
      crawler: '',
    });
    const { list } = data || {};
    setCrawlers(list || []);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Layout className="dbo-opinions-newsCrawlers">
      <Body>
        <Content>
          <ContentBody
            contentHeard={
              <Content.Header
                className="contentHead-normal"
                title={formatMessage({ id: 'News Crawlers' })}
              >
                <div className="crawlers-title">
                  {formatMessage({
                    id: 'In this section, all the news crawlers are listed out as below.',
                  })}
                </div>
              </Content.Header>
            }
          >
            <Data
              loading={loading}
              className="dbo-datamap-crawlers-table dbo-table-sticky"
              justifyClassName="crawlers-justify"
              searchClassName="crawlers-search"
              placeholder="Search by crawler"
              records={crawlers}
              recordKey="id"
              filterKey={['source', 'url']}
              columns={(pageIndex: number, pageSize: number, search = '') => [
                {
                  key: 'rank',
                  header: '#',
                  width: 80,
                  render: (record: any, text: any, index: number) =>
                    (pageIndex - 1) * pageSize + index + 1,
                },
                {
                  key: 'name',
                  header: formatMessage({ id: 'News Crawlers' }),
                  width: 500,
                  render: (record: any) => {
                    return record.source;
                  },
                },
                {
                  key: 'url',
                  header: 'url',
                  render: (record: any) => {
                    return keywordRenderFunc({
                      text: record.url,
                      keyword: search,
                    });
                  },
                },
                {
                  key: 'region',
                  header: formatMessage({ id: 'Region / Country' }),
                  render: (record: any) => {
                    return (
                      <RegionCountryItem isGlobal market={record.country} />
                    );
                  },
                },
              ]}
            ></Data>
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
};

export default NewsCrawlers;
